import { hapticFeedbackImpactOccurred, hapticFeedbackNotificationOccurred } from '@telegram-apps/sdk-react';

import { isTelegramConfigured } from './init';

/**
 * Виброотклик Telegram.
 *
 * Вне Telegram вызовы SDK бросают `ERR_UNKNOWN_ENV`, а не возвращают false
 * (src/telegram/init.ts), поэтому доступность проверяется всегда. Отклик —
 * не украшение: экран читают в темноте и вполглаза, и переворот карты
 * подтверждается рукой раньше, чем глазом.
 */
export function impact(style: 'light' | 'medium' | 'heavy' = 'medium'): void {
  if (!isTelegramConfigured() || !hapticFeedbackImpactOccurred.isAvailable()) return;
  hapticFeedbackImpactOccurred(style);
}

/** Отдельный отклик на важное событие партии: секретная карточка, отказ. */
export function notify(type: 'error' | 'success' | 'warning'): void {
  if (!isTelegramConfigured() || !hapticFeedbackNotificationOccurred.isAvailable()) return;
  hapticFeedbackNotificationOccurred(type);
}
